import './App.css';

function ContactUs() {
  return (
      <section className="contentSection">
        <div className="sectionHeading">
          <span className="sectionHeading__number">03</span>
          <div>
            <p className="eyebrow">Lobo Powerlifting</p>
            <h2>Contact Us</h2>
          </div>
        </div>

        <ul className="contactList">
          <li>
            <span className="contactList__icon" aria-hidden="true">@</span>
            <div>
              <span>Instagram</span>
              <a href="https://www.instagram.com/lobo.powerlifting">instagram.com/lobo.powerlifting</a>
            </div>
            <span className="contactList__arrow" aria-hidden="true">↗</span>
          </li>
          <li>
            <span className="contactList__icon" aria-hidden="true">✉</span>
            <div>
              <span>Email</span>
              <a href="mailto:lobopowerlifting@clubs.unm.edu">lobopowerlifting@clubs.unm.edu</a>
            </div>
            <span className="contactList__arrow" aria-hidden="true">↗</span>
          </li>
        </ul>
      </section>
  );
}

export default ContactUs;
